import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

import { projects } from "../data/projects";
import { ProjectCard } from "./ProjectCard";
import { LocalizedLink } from "./LocalizedLink";
import { useLanguage } from "../i18n/LanguageProvider";

const PREVIEW_COUNT = 3;

export const Projects = () => {
  const { t } = useLanguage();
  const preview = projects.filter((p) => p.featured).slice(0, PREVIEW_COUNT);

  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          className="text-sm tracking-widest uppercase text-zinc-500 font-medium mb-4"
        >
          {t("projects.label")}
        </motion.p>
        <motion.h2
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-3xl md:text-4xl font-semibold tracking-tight text-white/90 mb-16"
        >
          {t("projects.sectionTitle")}
        </motion.h2>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
          {preview.map((project, i) => (
            <ProjectCard key={project.id} project={project} index={i} />
          ))}
        </div>

        {/* View All */}
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.4, delay: 0.2 }}
          className="mt-10 flex justify-center"
        >
          <LocalizedLink
            to="/projects"
            data-testid="view-all-projects-btn"
            className="inline-flex items-center gap-2 bg-zinc-900 text-white border border-zinc-800 hover:border-zinc-700 hover:bg-zinc-800 px-6 py-3 rounded-full font-medium text-sm transition-colors duration-200"
          >
            {t("projects.viewAll")}
            <ArrowRight size={16} strokeWidth={1.5} />
          </LocalizedLink>
        </motion.div>
      </div>
    </section>
  );
};
